import styled from 'styled-components';

export const Container = styled.div`
	overflow: auto;

	.page-wrapper-container-header {
		margin-bottom: 0;
	}
`;

export const Iframe = styled.iframe`
	width: 100vw;
	min-height: calc(100vh + 150px);
	border: 0px;
`;

export const IframeWrapper = styled.div`
	display: inline-block;

	.ds-content-container-tabs {
		overflow: hidden;
		display: flex;
	}
`;

export const ContainerSpinner = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 30vh;
	width: 100vw;
	height: 100vh;
	background-color: white;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: auto;
	width: 100vw;
	height: 75vh;
	overflow: hidden;

	text-align: center;
`;
